<template>
    <div>
        <my-radio
        :data="[{key:'1',value:'通过'},{key:'3',value:'不通过'}]"
        v-model="model"
        ></my-radio>

        <el-input
        size="mini"
        v-if="model === '3'"
        v-model="modelOpinion"
        placeholder="不通过理由"
        ></el-input>
    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: String,
            default: ''
        },
        opinion: {
            type: String,
            default: ''
        },
        index: {
            type: Number,
            default: 0
        }
    },
    computed: {
        model: {
            get() {  console.log(this.value)
                return this.value;
              
            },
            set(val) {
                this.$emit('input', val);
                console.log(val)
            }
        },
        modelOpinion: {
            get() {
                return this.opinion;
            },
            set(val) {
                this.$emit('update:opinion', val);
                console.log(val)
            }
        }
    },
    created() {
        console.log(this.value)
        console.log(this.model)

    }
}
</script>